import React, { Component } from "react";
import { Button, Card, message, Spin, Modal, Select, Input } from "antd";
import { Table } from "components/table";
import { CAMS_VIEW_COLUMNS, CAMS_VIEW_COLUMNS_DEMO, CAMS_VIEW_STATUS_LOGS_COLUMNS } from "../../constants/columns";
import PropTypes from "prop-types";
import { STATE_STATUS } from "../../constants";
import { List, OrderedMap } from "immutable";
import { CaseService } from "../../services";


const onCellGenerator = (handleSave, _) => record => {
    return ({
        record,
        editable: true,
        dataIndex: _.dataIndex,
        title: record.header || _.title,
        handleSave,
        rules: record.rules || _.rules,
        fieldType: record.fieldType || _.fieldType,
        filesMultiple: _.filesMultiple ? _.filesMultiple : false,
        options: record.options || _.options,
        minRows : 1,
        // getFileUploadParams: _.getFileUploadParams,
        // uploadTarget: _.uploadTarget,
        viewable: true,
        max: record.max
    })
};


class CAMView extends Component {

    state = {
        camEngineTableData: [],
        newData: new OrderedMap({}),
        canDataLoader: false,
        breachedCaseStatus: null,
        statusRemarks: null,
        statusRemarkLogs: {},
        dataModalVisible: false,
        statusModalVisible: false
    }

    componentDidMount() {
        this.props.fetchCamEngineView(this.props.caseId);
        if (!this.props.isEmbedded) {
            this.props.fetchCamEngineStatusLogs(this.props.caseId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.camEngineStatus == STATE_STATUS.FETCHED && prevProps.camEngineStatus == STATE_STATUS.FETCHING) {
            this.creditEnhancementDbViewFn();
        }
        if(this.props.camEngineStatusLogsStatus == STATE_STATUS.FETCHED && prevProps.camEngineStatusLogsStatus == STATE_STATUS.FETCHING){
            this.setState({breachedCaseStatus: this.props.camEngineStatusLogsData?.breached_para_status,
                statusRemarkLogs: this.props.camEngineStatusLogsData?.status_remark_logs
                })
        }
    }

    groupByCategory(data, order) {
        const groupedData = {};

        // Initialize groupedData with empty arrays for each category in order
        order.forEach(category => {
            groupedData[category] = [];
        });

        // Group items by category
        data.forEach(item => {
            const category = item.category;
            if (groupedData.hasOwnProperty(category)) {
                groupedData[category].push(item);
            }
        })
        return groupedData;
    }

    creditEnhancementDbViewFn = () => {
        const camsApiData = this.props.camEngineData;
        for (let key in camsApiData) {
            if (camsApiData.hasOwnProperty(key)) {
                // Add the key property to each nested object
                camsApiData[key].key2 = key;
            }
        }
        const sortedData = camsApiData && Object.entries(camsApiData).sort(([keyA], [keyB]) => {
            const lastPartA = keyA.split('_').pop();
            const lastPartB = keyB.split('_').pop();

            const isIntA = !isNaN(lastPartA);
            const isIntB = !isNaN(lastPartB);

            if (isIntA && isIntB) {
                return parseInt(lastPartA) - parseInt(lastPartB);
            } else if (isIntA) {
                return 1;
            } else if (isIntB) {
                return -1;
            } else {
                return 0;
            }
        });
        const sortedObject = Object.fromEntries(sortedData);
        const CamViewDataApi = camsApiData && Object.values(sortedObject);
        const CamViewDataApi_demo = CamViewDataApi.filter(_ => _.key2 != 'negative_area' && _.key2 != 'growth_gst_turnover_24_months'
            && _.key2 != 'geo_portfolio_in_due_date' && _.key2 != 'geo_portfolio_in_90_plus_dpd'
            && _.key2 != 'recourse_perc' && _.key2 != 'retailer_risk_holdback_perc' &&
            _.key2 != 'mpa_risk_category' && _.key2 != 'anchor_portfolio_in_due_date' && _.key2 != 'anchor_portfolio_in_90_plus_dpd' && _.key2 != 'db_profitability' 
            && _.key2 != 'db_portfolio_in_due_date' && _.key2 != 'db_portfolio_in_90_plus_dpd'
        ).map(item => {
            if (item.key2 === 'percentile_limit_90th') {
                return { ...item, fact_value: "29,41,742" };  // updated
            }
            if (item.key2 === 'proposed_max_ticket_size_in_lacs') {
                return { ...item, fact_value: "2 Cr." };
            }
            if (item.key2 === 'program_size_os') {
                return { ...item, fact_value: "1 Cr." };
            }
            if (item.key2 === 'recourse_structure') {
                return { ...item, fact_value: "LMUG" };
            }
            if (item.key2 === 'db_profitability') {
                return { ...item, fact_value: "Rs 0.10 Cr." };
            }
            if (item.key2 === 'anchor_profitability') {
                return { ...item, fact_value: "Rs 5.43 Cr." };
            }

            return item; // unchanged
        });
        const CamViewDataApi_demo_141834 = CamViewDataApi.filter(_ => _.key2 != 'negative_area' && _.key2 != 'geo_portfolio_in_due_date' && _.key2 != 'geo_portfolio_in_90_plus_dpd' &&
            _.key2 != 'retailer_risk_holdback_perc' && _.key2 != 'anchor_portfolio_in_due_date' && _.key2 != 'anchor_portfolio_in_90_plus_dpd' && _.key2 != 'mpa_risk_category' &&
            _.key2 != 'mpa_anchor_recommendation'
        );

        const camsViewData = [];
        var data = this.props.caseId == 130090 ? CamViewDataApi_demo :  this.props.caseId == 141834 ? CamViewDataApi_demo_141834 : CamViewDataApi;
        data.forEach((el, idx) => {
            return (
                camsViewData.push({
                    "s_no": idx + 1,
                    "category": el?.category,
                    "fact_name": el?.fact_name,
                    "fact_value": el?.fact_value === true ? "True" : (el?.fact_value === false || el?.fact_value === "" || el?.fact_value === null) ? "False" : el?.fact_value,
                    "policy": typeof el?.policy == "boolean" ? String(el?.policy) : el?.policy || "NA",
                    "output": el?.output === true ? "Pass" : el?.output === false ? "Fail" : "Not Applicable",
                    "deviation": el?.deviation === "Yes" ? el.deviation_reason : el?.deviation === "No" ? "" : "",
                    "key2": el?.key2,
                    "approval_mandatory": el?.approval_mandatory,
                    "credit_remarks": el?.credit_remarks,
                    "approval_level": el?.approval_level
                }));
        });
        const categoryOrder = ["Profile", "General", "Ledger", "Banking", "GST", "Financial", "Geography", "DB", "Anchor", "Anchor MPA", "Bureau", "MPA", "Financials"];
        let output = this.groupByCategory(camsViewData, categoryOrder)
        output = Object.keys(output).map(_ => output[_]).flat()

        this.setState({ camEngineTableData: output, newData: new OrderedMap(camsApiData) });
    }

    getCustomTag = (_, key) => {
        if (key == "deviation") {
            return <label className="br-4" style={{ backgroundColor: _ === "Yes" ? "#f4f494" : "" }}> {_} </label>
        }
        return <div style={{ width: "100%" }}><label
            className="txt-light br-4"
            style={{ backgroundColor: _ === "Pass" ? "rgb(134 220 134)" : _ === "Fail" ? "rgb(238 142 142)" : "rgb(226 226 30)", padding: "0 10px 0 10px", display: "inline-block", width: "70%" }}
        >
            {_}
        </label></div>
    }
    updateDetails = () => {
        this.setState({
            canDataLoader: true
        })
        CaseService.updateCamsData(this.props.caseId, this.state.newData)
            .then((resp) => {
                this.setState({
                    canDataLoader: false
                })
                this.props.fetchCamEngineView(this.props.caseId);
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                this.setState({
                    canDataLoader: false
                })
                console.log(err);
            })
    }

    refreshCamData = () => {
        this.setState({
            canDataLoader: true
        })
        CaseService.refreshCamsData(this.props.caseId, this.state.newData)
            .then((resp) => {
                this.setState({
                    canDataLoader: false
                })
                this.props.fetchCamEngineView(this.props.caseId);
                this.props.fetchCaseDetail(this.props.caseId);
            })
            .catch((err) => {
                this.setState({
                    canDataLoader: false
                })
                console.log(err);
            })
    }


    handleSaveMultipleEntries = (record, values) => {
        if ((record.key || record.key == 0) && this.state.newData.size) {
            let data = this.state.newData.map((_, k) => {
                if (_.key2 == record.key2) {
                    return {
                        ..._,
                        ...values,
                        key: record.key
                    };
                }
                return _;
            });
            this.setState({
                newData: data
            });
        }
    }

    handleAssignCaseModal = () => {
        const breachedValue = {
            "approved": 1,
            "rejected": 2
        }
        const stageId = this.props.stageId;
        const stageCamStatusLogs= stageId && this.state.statusRemarkLogs && this.state.statusRemarkLogs[stageId];
        const body= {
            breached_para_status: this.state.breachedCaseStatus,
            camStatusRemarks: this.state.statusRemarks || stageCamStatusLogs && stageCamStatusLogs[stageCamStatusLogs?.length-1]?.remark,
            stageId: stageId,
            userId: this.props.user
        }
        CaseService.updateCamsBreachedCaseStatus(this.props.caseId, body).then(res=>{
            if(res?.status === 200){
                message.success(res?.data?.message || "Updated Successfully");
                this.setState({breachedCaseStatus: breachedValue[this.state.breachedCaseStatus]})
                this.props.fetchCaseDetail(this.props.caseId);
            }
        }).catch((err)=>{
            message.error("Something went wrong");
        })
    };

    render() {
        const breachedCaseStatus = {
            1: "Approved",
            2: "Rejected"
        }
        const stageNames = {
            7: "Credit Appraisal",
            8: "Progcap Credit"
          }
        const levelOfAuthority={
            0: "--",
            1: "L0",
            2: "L1",
            3: "L2",
            4: "L3",
            5: "L4"
        }

        const stageId= this.props.stageId;
        const stageCamStatusLogs= stageId && this.state.statusRemarkLogs && this.state.statusRemarkLogs[stageId];
        const StatusOptions=[{label:"Approved", value:1},{label:"Rejected", value:2}];
        const tableData = this.state.statusRemarkLogs && Object.entries(this.state.statusRemarkLogs).flatMap(([stageKey, records]) =>
        records.map(record => ({
            stage: stageNames[stageKey],
            remark: record.remark,
            userName: record.userName,
            breachedStatus: breachedCaseStatus[record.breached_para_status],
            levelOfAuthority: levelOfAuthority[record.level_of_authority] || "--",
        }))
        );
        return (
            <>
                <Spin spinning={this.props.camEngineStatus === STATE_STATUS.FETCHING || this.state.canDataLoader}>
                <Modal
                    title="Change Status"
                    visible={this.state.statusModalVisible}
                    closable={true}
                    destroyOnClose={true}
                    onOk={this.handleAssignCaseModal}
                    onCancel={()=> this.setState({ statusModalVisible: false })}
                    // okButtonProps={{
                        // disabled: !([7, 8].includes(stageId))
                        // (Number(this.props.user) !== (stageCamStatusLogs && stageCamStatusLogs[stageCamStatusLogs?.length-1]?.userId)))
                    // }}
                >

                    <div>
                    <Select
                          className="w-100 mb-10"
                          placeholder={"Select Status"}
                          onChange={(_) => this.setState({ breachedCaseStatus: _ })}
                        //   value={breachedCaseStatus[this.state.breachedCaseStatus] || undefined}
                      >
                          {StatusOptions.map((_, k) => (
                            <Select.Option value={_.value} key={k}>
                                {_.label}
                            </Select.Option>
                            ))}
                      </Select>
                      <Input.TextArea rows={4} 
                            placeholder="Remarks"
                            value={this.state.statusRemarks}
                            onChange={(e) => this.setState({statusRemarks: e.target.value})} />
                    </div>
                </Modal>
                <Modal
                    title="View Logs"
                    visible={this.state.dataModalVisible}
                    closable={true}
                    destroyOnClose={true}
                    onCancel={()=> this.setState({ dataModalVisible: false })}
                    footer={null}
                >
                    <div>
                    <Table
                        className="p-10 ant-col padless-card"
                        columns={CAMS_VIEW_STATUS_LOGS_COLUMNS()}
                        showColumnSelector={false}
                        data={List(tableData).toList()}
                        size="middle"
                        pagination={false}
                        showTopSection={false}
                        showFilters={false}
                        noRowSelection={true}
                        scrollY={500}
                        />
                    </div>
                </Modal>
                    <Card extra={[
                        <Button type={"link"} onClick={() => this.refreshCamData()} disabled={![4,5,18,20,7,8].includes(stageId)}  key="refresh">
                            Refresh
                        </Button>,
                        <Button type={"link"} onClick={() => this.updateDetails()} key="update" 
                            disabled={![7, 8].includes(stageId)}
                        >
                            Update
                        </Button>
                    ]}>
                        <Table
                            bordered
                            className="components-table-demo-nested p-10 ant-col padless-card custom-align-table-body-cam"
                            columns={
                                this.props.caseId == 130090 ? CAMS_VIEW_COLUMNS_DEMO(this.getCustomTag).map(({ editable, ...restColFields }) => {
                                    if (!onCellGenerator || !editable) {
                                        return { ...restColFields };
                                    }
                                    return {
                                        onCell: onCellGenerator(
                                            this.handleSaveMultipleEntries,
                                            restColFields
                                        ),
                                        ...restColFields
                                    };
                                }) : CAMS_VIEW_COLUMNS(this.getCustomTag).map(({ editable, ...restColFields }) => {
                                    if (!onCellGenerator || !editable) {
                                        return { ...restColFields };
                                    }
                                    return {
                                        onCell: onCellGenerator(
                                            this.handleSaveMultipleEntries,
                                            restColFields
                                        ),
                                        ...restColFields
                                    };
                                })
                            }
                            // columns={CAMS_VIEW_COLUMNS(this.getCustomTag)}
                            // data={List(this.state.camEngineTableData) || new List([])}
                            rowBGColor={"red"}
                            rowClassName={(record, index) => record.approval_mandatory ? "bgRed" : ""}
                            data={List(this.state.camEngineTableData).map((_, k) => {
                                let row = _;
                                if (row && typeof row === "object") {
                                    row.key = k;
                                    // row.sno = k+1;
                                    row.value = _.value;
                                    row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                                    row.credit_remarks = _.credit_remarks;
                                }
                                return row;
                            }).toList()}
                            size="middle"
                            pagination={false}
                            showTopSection={false}
                            showFilters={false}
                            noRowSelection={true}
                            editable={true}
                            scrollY={500}
                        />
                    </Card>
                    <Card>
                        <Table
                            title={<h2>Summary of Deviations</h2>}
                            spanConfig={{
                                title: 8,
                            }}
                            bordered
                            className="components-table-demo-nested p-10 ant-col padless-card custom-align-table-body-cam"
                            columns={
                                CAMS_VIEW_COLUMNS(this.getCustomTag).filter(el=>el.breachedPara)
                            }
                            showColumnSelector={false}
                            showCustomButtons={true}
                            // customButtons={
                            //     this.props.isEmbedded
                            //         ? [] :
                            //     [
                            //     {
                            //         text: "Status",
                            //         className: "status-btn",
                            //         onClick: () => this.setState({ statusModalVisible: true })
                            //     },
                            //     {
                            //         text: "View Logs",
                            //         className: "data-btn",
                            //         onClick: () => this.setState({ dataModalVisible: true })
                            //     }
                            // ]}
                            rowBGColor={"red"}
                            rowClassName={(record, index) => record.approval_mandatory ? "bgRed" : ""}
                            data={List(this.state.camEngineTableData).filter(el => el.output === "Fail").map((_, k) => {
                                let row = _;
                                if (row && typeof row === "object") {
                                    row.key = k;
                                    // row.sno = k+1;
                                    row.value = _.value;
                                    row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                                    row.credit_remarks = _.credit_remarks;
                                }
                                return row;
                            }).toList()}
                            size="middle"
                            pagination={false}
                            showTopSection={true}
                            showFilters={false}
                            noRowSelection={true}
                            editable={true}
                            scrollY={500}
                        />
                    </Card>
                </Spin>
            </>
        );
    }
}

CAMView.propTypes = {
    caseId: PropTypes.number,
    camEngineData: PropTypes.object,
    fetchCamEngineView: PropTypes.func,
    fetchCamEngineStatusLogs: PropTypes.func,
    fetchCaseDetail: PropTypes.func
};


export default CAMView;